<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.user)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                                <h4 class="order-title" style="display: flex;align-items: center;">
                                   <b>{{translate(locale.userInfo)}}</b>
                                    <router-link :to="'/users/edit/' + user.hash">
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">{{translate(locale.edit)}}</md-tooltip>
                                        </md-button>
                                    </router-link>
                                    <md-button class="md-just-icon md-simple md-primary" @click="openAction()">
                                        <md-icon>password</md-icon>
                                        <md-tooltip md-direction="top">{{translate(locale.resetPassword)}}</md-tooltip>
                                    </md-button>
                                </h4>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">{{translate(locale.userCode)}}</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell><b>{{user.hash || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.moiId)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.personal_code || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.govId)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.government_id || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userName)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.last_name_km}} {{user.first_name_km}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userNameLatin)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(user.phone).length > 0"><b>{{user.first_name_en}} {{user.last_name_en}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.dob)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(user.phone).length > 0"><b>{{user.dob}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.gender)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(user.phone).length > 0"><b>{{translate(config.getGender(user.gender))}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-50">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.phoneNumber)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>+{{user.phone_number}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.email)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.email}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userLogin)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{translate(config.datelify(user.last_login_date))}} </b> ({{translate(config.getAge(user.last_login_date))}})</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userLastIP)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.last_login_ip || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.totalLogin)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{user.total_login}} {{translate("Time(s)||ដង")}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">{{translate(locale.createdDate)}}</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell><b>{{translate(config.datelify(user.created_date))}} </b> ({{translate(config.getAge(user.created_date))}})</md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.status)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span class="late" v-if="user.status == 0">{{translate(locale.disabled)}}</span>
									        <span class="green" v-if="user.status == 1">{{translate(locale.active)}}</span>
                                        </md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
        <transition name="fade" mode="out-in">
            <div class="md-overlay md-fixed md-dialog-overlay" v-show="reset_password.active" @click="closeAction()"></div>
        </transition>
        
        <div class="md-dialog md-theme-default dialog-container" v-if="reset_password.active">
            <div class="md-layout" style="width: 100%;">
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
                    <h4 class="text-primary"><b>{{translate(locale.resetPassword)}}</b></h4>
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                    <md-field>
                        <label>{{translate(locale.password)}} *</label>
                        <md-input type="password" v-model="reset_password.password"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                    <md-field>
                        <label>{{translate(locale.confirmPassword)}} *</label>
                        <md-input type="password" v-model="reset_password.confirm_password"></md-input>
                    </md-field>
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                    <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
                    <md-button class="md-raised md-primary action-button" @click="reset()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.resetPassword)}}</md-button>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	export default {
		components: {  },
		created() {
			this.getUser();
		},
		data() {
			return {
				loaded: false,
				user: {
					hash: "",
					first_name_km: "",
					last_name_km: "",
					first_name_en: "",
					last_name_en: "",
					government_id: "",
                    personal_code: "",
                    dob: "",
                    gender: "",
                    phone_number: "",
                    email: "",
                    last_login_date: "",
                    last_login_ip: "",
                    total_login: "",
                    created_date: "",
                    status: ""
				},
                reset_password: {
                    active: false,
                    password: "",
                    confirm_password: ""
                }
			}
		},
		methods: {
			getUser() {
				this.$http.get(this.config.api + "/admin/user/get/" + this.$route.params.hash).then(data => {
					this.user = data.body.data;

					this.loaded = true;
				})
			},
			reset() {
                if(this.reset_password.password.length < 8) {
                    this.$notification.notify({message: "Please enter a password with more than 8 characters.||សូមបំពេញពាក្យសម្ងាត់ វែងជាង ៨ តួរអក្សរ។", icon: 'feedback', type: 'danger'});
                    return false;
                }
                if(this.reset_password.password != this.reset_password.confirm_password) {
                    this.$notification.notify({message: "Confirm Password does not match.||បញ្ជាក់ពាក្យសម្ងាត់មិនត្រឹមត្រូវ។", icon: 'feedback', type: 'danger'});
                    return false;
                }
				this.$http.post(this.config.api + "/admin/user/set_password", {
                    hash: this.$route.params.hash,
                    password: this.reset_password.password
                }).then(data => {
                    if (data.body.status == 'success') {
                        this.closeAction();
                        this.$notification.notify({message: "You have updated this user successfully.||អ្នកបានកែប្រែអ្នកប្រើប្រាស់បានដោយជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.getUser();
                    }
                })
			},
            openAction(name) {
                this.reset_password.active = true;
            },
            closeAction() {
                this.reset_password.active = false;
                this.reset_password.password = "";
                this.reset_password.confirm_password = "";
            },
		}
	}
</script>
<style scoped>
	.dialog-container {
        width: 90%; 
        max-width: 800px !important; 
        padding: 15px; 
        border-radius: 6px;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
    .action-button {
        margin-left: 8px !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Users/Detail.vue